import { installEmailTypoHint } from "../libs/email-typo-hint";

const cleanup = installEmailTypoHint();
const hot = (import.meta as ImportMeta & { hot?: { dispose: (cleanup: () => void) => void } }).hot;
hot?.dispose(cleanup);
